export const IOS = 'IOS';
export const ANDROID = 'ANDROID';